enum ModeEnum {
	Simple = 0,
	Advanced = 1
}

export default ModeEnum;